import { useState, useEffect } from "react";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { EmojiSidebar } from "./components/EmojiSidebar";
import { EmojiWall } from "./components/EmojiWall";
import { AddEmojiForm } from "./components/AddEmojiForm";
import { Footer } from "./components/Footer";
import { allEmojis } from "./emojiList";
import { getSavedEmojis, saveEmojiToFirebase } from "./firebase";

const App = () => {
  const [emojis, setEmojis] = useState([]);
  const [availableEmojis, setAvailableEmojis] = useState([]);
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  const [link, setLink] = useState("");
  const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

  useEffect(() => {
    const fetchEmojis = async () => {
      const savedEmojis = await getSavedEmojis();
      const savedEmojiList = savedEmojis.map(e => e.emoji);
      setEmojis(savedEmojis);
      setAvailableEmojis(allEmojis.filter(e => !savedEmojiList.includes(e.emoji)));
    };
    fetchEmojis();
  }, []);

  const handleSelectEmoji = (emoji) => {
    setSelectedEmoji(emoji);
    setAvailableEmojis(prev => prev.filter(e => e.emoji !== emoji));
  };

  const handlePaymentSuccess = async () => {
    if (selectedEmoji && link) {
      await saveEmojiToFirebase(selectedEmoji, link);
      setEmojis([...emojis, { emoji: selectedEmoji, link }]);
      setSelectedEmoji(null);
      setAvailableEmojis(prev => prev.filter(e => e.emoji !== selectedEmoji));
    }
  };

  return (
    <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID || "" }}>
      <div className="flex flex-col min-h-screen">
        <div className="flex flex-col md:flex-row flex-grow">
          <EmojiSidebar emojis={availableEmojis} onSelectEmoji={handleSelectEmoji} />
          <div className="flex flex-col w-full md:w-3/4 items-center">
            <AddEmojiForm 
              selectedEmoji={selectedEmoji} 
              link={link} 
              setLink={setLink}
              onPaymentSuccess={handlePaymentSuccess} 
            />
            <EmojiWall emojis={emojis} />
          </div>
        </div>
        <Footer />
      </div>
    </PayPalScriptProvider>
  );
};

export default App;
